import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-72c8c117"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "header-style"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "后台管理", -1);
});

var _hoisted_3 = /*#__PURE__*/_createTextVNode("返回首页");

var _hoisted_4 = {
  class: "footer-container"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode("本系统由vue+go强力驱动");

var _hoisted_6 = /*#__PURE__*/_createTextVNode("©版权所有2016-2022 蜀ICP备18012666号");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_arrow_right_bold = _resolveComponent("arrow-right-bold");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_arrow_left_bold = _resolveComponent("arrow-left-bold");

  var _component_el_menu_item = _resolveComponent("el-menu-item");

  var _component_el_sub_menu = _resolveComponent("el-sub-menu");

  var _component_el_menu = _resolveComponent("el-menu");

  var _component_el_aside = _resolveComponent("el-aside");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_header = _resolveComponent("el-header");

  var _component_router_view = _resolveComponent("router-view");

  var _component_el_main = _resolveComponent("el-main");

  var _component_el_link = _resolveComponent("el-link");

  var _component_el_footer = _resolveComponent("el-footer");

  var _component_el_container = _resolveComponent("el-container");

  return _openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_aside, {
        width: $setup.isCollapse ? '64px' : '200px'
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "menu-switch",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return $setup.isCollapse = !$setup.isCollapse;
            })
          }, [_withDirectives(_createVNode(_component_el_icon, {
            color: "#fff"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_arrow_right_bold)];
            }),
            _: 1
          }, 512), [[_vShow, $setup.isCollapse]]), _withDirectives(_createVNode(_component_el_icon, {
            color: "#fff"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_arrow_left_bold)];
            }),
            _: 1
          }, 512), [[_vShow, !$setup.isCollapse]])]), _createVNode(_component_el_menu, {
            "active-text-color": "#ffd04b",
            "background-color": "#545c64",
            "default-active": "/welcome",
            "text-color": "#fff",
            "unique-opened": true,
            "collapse-transition": false,
            onOpen: $setup.handleOpen,
            onClose: $setup.handleClose,
            collapse: $setup.isCollapse,
            router: ""
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.adminData.menus, function (item) {
                return _openBlock(), _createBlock(_component_el_sub_menu, {
                  index: "".concat(item.id),
                  key: item.id
                }, {
                  title: _withCtx(function () {
                    return [_createVNode(_component_el_icon, null, {
                      default: _withCtx(function () {
                        return [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))];
                      }),
                      _: 2
                    }, 1024), _createElementVNode("span", null, _toDisplayString(item.label), 1)];
                  }),
                  default: _withCtx(function () {
                    return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, function (child) {
                      return _openBlock(), _createBlock(_component_el_menu_item, {
                        index: child.path,
                        key: child.path
                      }, {
                        default: _withCtx(function () {
                          return [_createTextVNode(_toDisplayString(child.label), 1)];
                        }),
                        _: 2
                      }, 1032, ["index"]);
                    }), 128))];
                  }),
                  _: 2
                }, 1032, ["index"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["onOpen", "onClose", "collapse"])];
        }),
        _: 1
      }, 8, ["width"]), _createVNode(_component_el_container, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_header, null, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                plain: "",
                onClick: $setup.handleBreakHome
              }, {
                default: _withCtx(function () {
                  return [_hoisted_3];
                }),
                _: 1
              }, 8, ["onClick"])])];
            }),
            _: 1
          }), _createVNode(_component_el_main, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_router_view)];
            }),
            _: 1
          }), _createVNode(_component_el_footer, null, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_link, {
                type: "danger",
                underline: false,
                disabled: true
              }, {
                default: _withCtx(function () {
                  return [_hoisted_5];
                }),
                _: 1
              }), _createVNode(_component_el_link, {
                type: "danger",
                href: "https://beian.miit.gov.cn",
                underline: false
              }, {
                default: _withCtx(function () {
                  return [_hoisted_6];
                }),
                _: 1
              })])];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  });
}